import Button from './Button'
import Carousel from './Carousel'
import Menu from './Menu'
import Message from './Message'

import { setters } from 'src/helpers'

export default class BotResponse {
  // messages: [Message]
  // quickReplies: [Button]
  // carousel: Carousel
  // fetchNext: bool
  // menu: { buttons: [Button], config: {} }
  // forceReply: bool - disables text input
  // theme

  constructor() {
    this._messages = []
    this.fetchNext = false
    this._forceReply = false
    this._dateInput = false
    this._blink = false
    this._blinkColor = ''
  }

  set messages(messages) { setters.arrayOfType.call(this, '_messages', messages, Message) }
  get messages() { return this._messages.map(msg => msg.toJSON()) }

  set quickReplies(buttons) { setters.arrayOfType.call(this, '_quickReplies', buttons, Button) }
  get quickReplies() { return this._quickReplies.map(btn => btn.toJSON()) }

  set menu(menu) { setters.instanceOf.call(this, '_menu', menu, Menu) }
  get menu() { return this._menu }

  set carousel(carousel) { setters.instanceOf.call(this, '_carousel', carousel, Carousel) }
  get carousel() { return this._carousel }

  set forceReply(value) { setters.bool.call(this, '_forceReply', value)}
  get forceReply() { return this._forceReply }
  set blink(value) { setters.bool.call(this, '_blink', value)}
  get blink() { return this._blink }
  set blinkColor(value) { setters.string.call(this, '_blinkColor', value)}
  get blinkColor() { return this._blinkColor }

  set dropdownInput (value) { setters.bool.call(this, '_dropdownInput', value)}
  get dropdownInput () { return this._dropdownInput }
  set dateInput (value) { setters.bool.call(this, '_dateInput', value)}
  get dateInput () { return this._dateInput }

  set theme(value) { setters.object.call(this, '_theme', value)}
  get theme() { return this._theme }

}


// WEBPACK FOOTER //
// ./src/App/services/types/BotResponse.js